import React from 'react';
import { ActionButtonGroup, PauseBillingDetailsFooter } from '../../../shared';
import { useBillingActions, useFlowActions } from '../../../../context';

/**
 * Component that displays the pause offer for users who select "technicalIssues" as their reason
 * Offers support assistance and a 30-day billing pause while issues are resolved
 */
const TechnicalIssuesPauseOffer = () => {
  // Get actions from context
  const { pause } = useBillingActions();
  const { cancelAnyway } = useFlowActions();

  return (
    <div className="technical-issues-pause-offer-content">
      <div className="mb-4">
        <h5 className="mb-3">Having trouble with your membership? We're here to help.</h5>
        <p className="mb-3">
          We know how frustrating tech troubles can be — and we're so sorry that's been part of your experience. That's
          never what we want for our members!
        </p>
        <p className="mb-3">
          Our Support Team is ready to work one-on-one with you to get everything running smoothly again. Whether it's
          login issues, missing content, or access problems, we'll make it right.
        </p>
        <p className="mb-3">
          And to make sure you're not paying for time you can't fully use, we want to invite you to{' '}
          <strong>pause your billing for 30 days</strong> while we sort things out. You'll still have full access to
          your recipes, lessons, and community during this time.
        </p>
        <p className="mb-4">
          This gives us time to fix the issue — and gives you uninterrupted access, without any added cost or stress.
        </p>

        <ActionButtonGroup
          primaryAction={{
            text: 'Connect with Support & Pause My Billing',
            onClick: pause,
            color: 'primary',
            className: 'mb-3'
          }}
          secondaryAction={{
            text: 'Cancel Anyway',
            onClick: cancelAnyway
          }}
          layout="vertical"
        />

        <PauseBillingDetailsFooter className="pause-details mb-3" />
      </div>
    </div>
  );
};

export default TechnicalIssuesPauseOffer;
